/**
 * External dependencies
 */
import React from 'react';
import { Box, Heading, Stack } from '@towersystems/towersystems-design-system';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import Navigation from 'modules/app/shopify/navigation';

/**
 * Style dependencies
 */
import './styles.scss';

const AppComponent = (props) => {
    return <Main>
        <Stack space="large">
            <Navigation section="general"/>
            <Heading level='1'>Shopify</Heading>
        </Stack>
    </Main>
}

export default AppComponent;
    